import {
  IconBrandLinkedin,
  IconBrandInstagram,
  IconBrandYoutube,
  IconBrandFacebook
} from "@tabler/icons-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="text-white" style={{ backgroundColor: '#000' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl py-10 sm:py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-8 sm:mb-12">
          {/* Logo e Descrição */}
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
              <img
                src="/images/logo-brld.svg"
                alt="BRLD Logo"
                className="h-8 sm:h-10 w-auto brightness-0 invert"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
              <span className="text-lg sm:text-xl font-semibold text-white">stableBRLD</span>
            </div>
            <p className="text-slate-400 text-xs sm:text-sm mb-4 sm:mb-6 max-w-sm">
              BRLD: o real programável da Liqi para liquidação institucional e tesouraria corporativa. Uma stablecoin 1:1 com o real, projetada para operações em blockchain.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/liqibr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <IconBrandLinkedin className="w-5 h-5 sm:w-6 sm:h-6" strokeWidth={1.5} />
              </a>
              <a
                href="https://www.instagram.com/liqibr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <IconBrandInstagram className="w-5 h-5 sm:w-6 sm:h-6" strokeWidth={1.5} />
              </a>
              <a
                href="https://www.youtube.com/@LiqiDigitalAssets"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white transition-colors"
                aria-label="YouTube"
              >
                <IconBrandYoutube className="w-5 h-5 sm:w-6 sm:h-6" strokeWidth={1.5} />
              </a>
              <a
                href="https://www.facebook.com/Liqibr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <IconBrandFacebook className="w-5 h-5 sm:w-6 sm:h-6" strokeWidth={1.5} />
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Links Rápidos</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <button onClick={() => scrollToSection("o-que-e")} className="text-slate-400 hover:text-white transition-colors">
                  O que é BRLD
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("pilar-liquidacao")} className="text-slate-400 hover:text-white transition-colors">
                  Moeda de liquidação
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("pilar-tesouraria")} className="text-slate-400 hover:text-white transition-colors">
                  Tesouraria corporativa
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("seguranca")} className="text-slate-400 hover:text-white transition-colors">
                  Segurança
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("faq")} className="text-slate-400 hover:text-white transition-colors">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Contato</h4>
            <a
              href="mailto:contato@liqi.com.br"
              className="text-slate-400 hover:text-white transition-colors text-xs sm:text-sm block mb-2"
            >
              contato@liqi.com.br
            </a>
            <p className="text-slate-400 text-[10px] sm:text-xs">
              Atendimento de segunda à sexta das 09:00 às 18:00.
            </p>
          </div>
        </div>

        {/* Copyright e Links Legais */}
        <div className="border-t border-slate-700 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-slate-400 text-xs sm:text-sm text-center sm:text-left">
              © {currentYear} Liqi Digital Assets. Todos os direitos reservados.
            </p>
            <div className="flex gap-4 sm:gap-6 text-xs sm:text-sm">
              <a
                href="https://www.liqi.com.br/documents/privacy-policy/document.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white transition-colors"
              >
                Política de Privacidade
              </a>
              <a
                href="https://www.liqi.com.br/documents/terms-of-use/document.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white transition-colors"
              >
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
